const makeZeroArray = length => new Array(length).fill(0);
const zeroSeries = length => [{ data: makeZeroArray(length) }];

function createSingleSeries(series) {
  const { enable, data_title_postfix, ...rest } = series;
  return {
    visible: enable,
    dataTitlePostfix: data_title_postfix,
    ...rest,
  };
}

function addSumToSeries(sum, result) {
  if (sum) {
    const sumSeries = createSingleSeries(sum);
    //Temporary!! => until server add type in sended series
    sumSeries.type = 'line';
    sumSeries.name = sumSeries.title;
    result.push(sumSeries);
  }
}

function transformSeries(primaryChart) {
  const { series, sum, dates } = primaryChart;
  const result = series.length
    ? series.map(createSingleSeries)
    : zeroSeries(dates.length);
  addSumToSeries(sum, result);
  return result;
}

function getSumOfSeries(chart) {
  const { title, series } = chart;
  let sumData;
  let isVisible;
  if (series.length === 1) {
    const { data, enable } = series[0];
    sumData = data;
    isVisible = enable;
  } else {
    const {
      sum: { data: dataOfSum, enable },
    } = chart;
    sumData = dataOfSum;
    isVisible = enable;
  }
  return {
    name: title,
    data: sumData,
    visible: isVisible,
  };
}

export { transformSeries, getSumOfSeries };
